import React from 'react'
import StaticsProducePage from "../statics-produce/StaticsProducePage"
import StaticsCreatedPage from "../statics-created/StaticsCreatedPage"
import StaticsOvertime from "../statics-overtime/StaticsOvertime"
import store from 'store'
import StaticsAveragePage from "../statics-average/StaticsAveragePage";
import StaticsCutoffPage from '../statics-cutoff/StaticsCutoffPage'
import StaticsOrderHourPage from '../statics-order-hour/StaticsOrderHourPage'
import ForecastShipBatchPage from '../forecast-ship-batch/ForecastShipBatchPage'
import ProductionEfficiencyPage from '../production-efficiency/ProductionEfficiencyPage'
import EstimatedItemPage from '../statics-estimated-item/EstimatedItemPage'
import NgRatePage from '../ng-rate/components/NgRatePage'
import { updateWindowLocation } from '../../helpers/windowURI'
import queryString from "query-string";

class StatisticsViewV2 extends React.Component {
    state = {
        activeTab: store.get('activeTab') || 'overtime'
    }

    _onChangeTabActive = (active) => {
        this.setState({
            activeTab: active
        }, () => {
            store.set('activeTab', this.state.activeTab)
            updateWindowLocation({})
        })
    }

    componentDidMount() {
        const params = queryString.parse(window.location.search)
        const { cutoff_type } = params || {}
        if (cutoff_type) {
            this.setState({
                activeTab: 'cutoff',
            }, () => {
                store.set('activeTab', this.state.activeTab)
                updateWindowLocation({})
            })
        }
    }

    render() {
        const { activeTab } = this.state

        const tabContent = {
            overtime: <StaticsOvertime />,
            produce: <StaticsProducePage />,
            created: <StaticsCreatedPage />,
            average: <StaticsAveragePage />,
            cutoff: <StaticsCutoffPage />,
            order_hour: <StaticsOrderHourPage />,
            forecast_ship_batch: <ForecastShipBatchPage />,
            production_efficiency: <ProductionEfficiencyPage />,
            estimated_item: <EstimatedItemPage />,
            ng_rate: <NgRatePage />
        }

        return (
            <div className='StatisticsView'>
                <div className="page-title">
                    <h1 className="mb-0 font-weight-black">Hệ thống quản trị KTS Bình Minh</h1>
                </div>

                <div className='TabHead'>
                    <ul className='TabFilter'>
                        <li
                            className={`${activeTab === 'overtime' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('overtime')}
                        >
                            Thống kê quá hạn
                        </li>
                        <li
                            className={`${activeTab === 'produce' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('produce')}
                        >
                            Thống kê sản xuất
                        </li>
                        <li
                            className={`${activeTab === 'created' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('created')}
                        >
                            Thống kê số lượng hàng hóa theo thời gian
                        </li>
                        <li
                            className={`${activeTab === 'average' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('average')}
                        >
                            Thống kê thời gian sản xuất
                        </li>
                        <li
                            className={`${activeTab === 'cutoff' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('cutoff')}
                        >
                            Thống kê cutoff
                        </li>
                        <li
                            className={`${activeTab === 'order_hour' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('order_hour')}
                        >
                            Thống kê đơn theo giờ
                        </li>
                        <li
                            className={`${activeTab === 'forecast_ship_batch' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('forecast_ship_batch')}
                        >
                            Khối lượng ship
                        </li>
                        <li
                            className={`${activeTab === 'production_efficiency' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('production_efficiency')}
                        >
                            Hiệu suất sản xuất
                        </li>
                        <li
                            className={`${activeTab === 'estimated_item' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('estimated_item')}
                        >
                            Lượng hàng dự kiến
                        </li>
                        <li
                            className={`${activeTab === 'ng_rate' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('ng_rate')}
                        >
                            Kiểm soát chất lượng
                        </li>
                    </ul>
                </div>

                <div className='tabContent'>
                    {tabContent[activeTab]}
                </div>
            </div>
        )
    }
}

export default StatisticsViewV2
